import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store";
import util from "@/libs/util.js";
import routes from "./routes";

Vue.use(VueRouter);

// 1. 修复：彻底解决重复跳转报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 忽略重复跳转错误，捕获其他异常
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

store.commit("d2admin/router/init", routes);

const router = new VueRouter({
  routes,
});

/**
 * 路由拦截优化版
 */
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  store.commit("d2admin/search/set", false);

  const token = util.cookies.get("token");
  const menuNameList = store.state.d2admin.router.menuNameList || [];

  // 检查目标路由是否存在（防止 Duplicate Name 导致的匹配失败）
  const route = store.state.d2admin.router.flatRouteList[to.name] || {};

  // A. 白名单
  if (route.meta?.pass) {
    return next();
  }

  // B. 已登录
  if (token && token !== "undefined") {
    if (to.name === 'login') {
      // 已登录状态下去登录页，直接弹回首页
      return next({ name: 'index' });
    }

    // 关键逻辑：如果没菜单数据（冷启动/直接输入URL）
    if (menuNameList.length === 0) {
      // 这里你可以选择直接放行，让具体的 page 组件去执行 store.dispatch('load')
      // 但为了防止转圈，我们确保 next 能够顺利完成
      next();
    } else {
      // 正常的权限判断
      if (route.meta?.hidden || route.meta?.auth || route.name === 'index') {
        next();
      } else if (!from.name && !to.name) {
        // 刷新页面，优先保 index
        const hasIndex = menuNameList.some(item => item.toLowerCase() === 'index');
        next({ name: hasIndex ? 'index' : (menuNameList[0] || '/') });
      } else {
        next();
      }
    }
  }
  // C. 未登录
  else {
    if (to.name !== 'login') {
      next({
        name: 'login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  }
});

router.afterEach((to) => {
  NProgress.done();
  store.dispatch("d2admin/page/open", to);
  util.title(to.meta.title);
});

export default router;
